<!-- 服务项目信息编辑页 -->
<template>
    <div class="edit white">
        <drawer 
            title="更新身份证" 
            :dialogShow="dialogShow" 
            @handleChange="handleChangeDrawer"
        >
            <div slot="body">
                <div class="details">
                    <el-form ref="form" :model="form" class="demo-ruleForm" label-width="110px">
                        <el-form-item label="姓名：" prop="staffName" :rules="$rules.required">
                            <el-input v-model="form.staffName"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号码：" prop="idCardNo" :rules="$rules.cardNum">
                            <el-input v-model="form.idCardNo"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证正面：" prop="idCardFrontUrl" :rules="$rules.required">
                            <imgUpload @file="getFileCardFront" :fileList="form.idCardFrontUrl" module="idcard"></imgUpload>
                        </el-form-item>
                        <el-form-item label="身份证反面：" prop="idCardBackUrl" :rules="$rules.required">
                            <imgUpload @file="getFileCarBack" :fileList="form.idCardBackUrl" module="idcard"></imgUpload>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="drawer-footer">
                    <div class="btns">
                        <el-button type="primary" @click="save">保存</el-button>
                    </div>
                </div>
            </div>
        </drawer>
    </div>
</template>

<script>
    import imgUpload from '../../../components/common/modules/upload'
    import drawer from '../../../components/common/drawer'
    export default {
        data() {
            return {
                dialogShow: false,
                form: {
                    staffName: '', //姓名
                    idCardBackUrl: "", //身份证反面
                    idCardFrontUrl: "",//身份证正面
                    idCardNo: "", //身份证号码
                },
            };
        },

       components:{
            imgUpload,
            drawer
        },

        computed: {},

        created() {
            this.init()
        },
        // activated(){
        //     this.init();
        // },
        methods: {
            handleChangeDrawer(val){
                this.dialogShow = false;
            },
            getFileCardFront(res){ //身份证正面
                this.form.idCardFrontUrl = res;
            },
            getFileCarBack(res){ //身份证反面
                this.form.idCardBackUrl = res;
            },
            //  页面初始化函数
            init(id) {
                this.$on('set',function(id){
                    Object.assign(this.$data,this.$options.data());
                    this.$api.get(this.$url.companyStaff.get,{
                        id: id
                    }).then(res => {
                        if(res){
                            this.dialogShow = true;
                            this.form.id = res.id;
                            this.form.staffName = res.staffName;
                            this.form.idCardBackUrl = res.idCardBackUrl;
                            this.form.idCardFrontUrl = res.idCardFrontUrl;
                            this.form.idCardNo = res.idCardNo;
                        }
                    });
                })
                
            },
            back(){
                this.$router.back()
            },
             // 保存
            save() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.$api.post(this.$url.companyStaff.updateIdCard,this.form).then(res => {
                            if(res){
                                this.$api.success()
                                this.dialogShow = false;
                                this.$emit('handleChangeCard',false);
                            }
                        })
                    }
                });
            }
        }
    }
</script>
<style lang='less' scoped>
.el-form .shops,.el-form .shops .el-input{
    width: 100%;   
    height: auto;
    line-height: 1;
} 
.el-button+.el-button{

}
.buttonNot{
    margin-left: 0;
}
    .file{
        padding: 0;
        height: 110px;
    }
    // .el-form .el-input{
    //     width: auto;
    // }
    .el-form .el-select{
        // width: auto;
    }
    .el-radio {
        display: inline-block;
    }
    .el-form-item__content .file{
        padding: 0;
        height: 110px;
    }
    .foot{
        text-align: center;
        margin-top: 20px;
    }

    .unit {
        float: right;
        height: 40px;
        line-height: 40px;

        input {
            height: 40px;
            border: 1px solid #DCDFE6;
            border-radius: 4px 0px 0px 0px;
            box-sizing: border-box;
            width: 125px;
            float: left;
            padding-left: 12px;
            border-right: 0;
        }

        span {
            border: 1px solid #DCDFE6;
            height: 40px;
            display: inline-block;
            width: 36px;
            text-align: center;
            line-height: 40px;
            border-radius: 0 4px 4px 0;
            box-sizing: border-box;
            border-radius: 0px 4px 4px 0px;
            font-size: 12px;
            color: #03B7C7;
        }
    }

    .table {
        margin-bottom: 40px;
    }

    .title span {
        font-size: 12px;
        color: #ccc;
        position: relative;
        top: 0px;
    }


    .filelength {
        font-size: 12px;
        color: #4E5155;
        margin-left: 20px;
    }


    .titleForm {
        margin-bottom: 5px ;
        background-color: #fff;
        font-size: 12px !important;
    .code {
        margin: 0 40px 0 10px;
        width: 224px;
        height: 32px;
    }
    .main{
        margin-left: 40px;
        padding: 12px 0;

        font-size: 13px;
        line-height: 14px;

    .tag-group__title{
        padding: 0 5px;
    }
    }
    }
</style>
